import styled from 'styled-components';
import MediaPreviewIcon from '../../atoms/MediaPreviewIcon/MediaPreviewIcon';

export const PreviewVideo = styled.video`
  width: 100%;
`;
export const OpenedVideo = styled.video`
  display: block;
  width: 100%;
  height: 100%;
`;

export const ModalBackground = styled.div`
  background: black;
  display: flex;
  justify-content: center;
  align-items: center;
  height: calc((80vw / 16) * 9);
  max-height: 90vh;
  max-width: 100vw;
`;

export const CenteredMediaPreviewIcon = styled(MediaPreviewIcon)`
  position: absolute;
`;
